import React, { FC } from 'react';

import styles from './SbRespPlaceholderTile.scss';

export const SbRespPlaceholderTile: FC = () => (
    <div className={styles.wrapper}>
        <div className={styles.tile}>
            <div className={styles.image} />
            <div className={styles.title} />
            <div className={styles.subtitle} />
            <div className={styles.price} />
        </div>
    </div>
);
